'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search = require('./remote/search');

var Search = {
    fetchCategoryResults: function fetchCategoryResults(params) {
        return _search.SearchRemote.fetchCategoryResults(params);
    },
    fetchSearchFacetsResults: function fetchSearchFacetsResults(params) {
        return _search.SearchRemote.fetchSearchFacetsResults(params);
    },
    fetchSearchResults: function fetchSearchResults(params) {
        return _search.SearchRemote.fetchSearchResults(params);
    }
};

exports.default = Search;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/search.js
// module id = TdMF
// module chunks = 46